import application from "@homer.core/application";
import module from "@homer.core/module";
import Demand from "@homer.core/demand";

// BFCache/WebView restore paths can re-run this file in the same document, so only upgrade the initial stub once.
if (globalThis.demand?.stub === true) {
    globalThis.demand = new Demand({
        resolver: module.resolve,
        processor: module.process,
        version: application.version,
        cache: application.cache,
        stub: globalThis.demand,
    });
}
